<template>
    <div>
            <form class="my-form" v-if="canManageFiles">
                <p>Upload multiple files with the file dialog or by dragging and dropping images onto the window below</p>
                <input type="file" id="fileAttachmentElem" multiple accept="*/*" ref="fileAttachmentElem" v-on:change="handleFileAttachmentInput">
                <label class="btn btn-primary" for="fileAttachmentElem">Add Files</label>
            </form>

            <div id="dropArea"
                v-on:dragstart="handleDragStart"
                v-on:dragover="handleDragOver"
                v-on:dragenter="handleDragEnter"
                v-on:dragleave="handleDragLeave"
                v-on:dragend="handleDragEnd"
                v-on:drop="handleDrop"
                v-on:drag="handleDrag"
            >
                <div class="file_card" v-for="file in attachments">
                    <a :href="getFileUrl(file)">
                        <div class="icon" v-html="file.icon"></div>
                    </a>
                    <div class="caption">{{ file.file_name }}</div>
                    <div class="actions" v-if="canManageFiles"><span class="btn btn-xs btn-danger" v-on:click="deleteFile(file)"><i class="fas fa-trash-alt"></i>&nbsp;Remove</span></div>
                </div>
                <div class="clearfix"></div>
            </div>
    </div>

</template>

<style scoped>

#dropArea {
  border: 1px solid #BCC8CD;
  border-radius: 8px;
  background-color: #ECF6FB;
  width: 100%;
  font-family: sans-serif;
  margin: 0px auto;
  padding: 32px;
}
#dropArea.highlight {
  border-color: blue;
}
p {
  margin-top: 0;
}
.my-form {
  margin-bottom: 10px;
}

#fileAttachmentElem {
  display: none;
}
.file_card {
    width: 112px;
    border: 1px #ccc;
    border-radius: 8px;
    padding: 0px;
    margin: 16px;
    float: left;
}
.file_card .caption {
    width: 100%;
    height: 80px;
    text-overflow: hidden;
    margin: 8px auto;
    text-align: center;
    font-size: 1em;
    word-wrap: break-word;
}
.file_card .icon {
    width: 112px;
    height: 96px;
    padding: 16px 16px 0 16px; /* Padding left / right / top for the image */
}
.file-card .icon:hover {
    cursor: pointer;
}
.actions {
    text-align: center;
}
</style>
<script>
    import _ from 'lodash';
    import axios from 'axios';

    export default {

        props: {

                model_type: {
                    type: String,
                    default: null
                },
                model_id: {
                    type: Number,
                    default: null,
                },
                collection_name: {
                    type: String,
                    default: "tmp_media"
                },
                can_manage_files: {
                    type: Boolean,
                    default: false
                },
        },

        data() {
            return {
                modelType: this.model_type,
                modelId: this.model_id,
                collectionName: this.collection_name,
                canManageFiles: this.can_manage_files,
                attachments:  []
            };
        },
        mounted() {
            this.init();
        },
        computed: {
        },
        methods: {
            init() {
                console.log('MediaAttachment.init()');
                console.log('MediaAttachment.init() - Model: ' + this.modelType + ' (' + this.modelId + ')');
                this.resetTmpFiles();
                this.refreshFiles();

                if (this.post_id) {
                    console.log('MediaAttachment.init() : Loading post')
                    this.type = 'update';
                    this.getPost();
                }
            },
            setModel(model_type, model_id) {
                this.modelType = model_type;
                this.modelId = model_id;
            },
            resetTmpFiles() {
                

                let url = '/api/v1/media/clear_member_tmp_collection/' + this.collectionName;

                axios.post(url).then((response) => {
                    console.log(response.data);
                }).catch((error) => {
                    console.log(error);
                    this.handleHTTPError(error);
                });

            },
            refreshFiles() {
                this.getAttachments();
            },
            setFiles(files) {
                this.attachments = files;
                this.attachments = _.sortBy(this.attachments, ['file_name']);
            },
            handleDragStart(event) {
                console.log('Drag Start');
            },
            handleDragOver(event) {
                console.log('Drag Over');
                event.preventDefault();
                event.stopPropagation();
                dropArea.classList.add('highlight');
            },
            handleDragEnter(event) {
                console.log('Drag Enter');
                event.preventDefault();
                event.stopPropagation();
                dropArea.classList.add('highlight');
            },
            handleDragLeave(event) {
                console.log('Drag Leave');
                event.preventDefault();
                event.stopPropagation();
                dropArea.classList.remove('highlight');
            },
            handleDragEnd(event) {
                console.log('Drag End');
            },
            handleDrop(event) {
                console.log('Drag Drop');
                event.preventDefault();
                event.stopPropagation();
                dropArea.classList.remove('highlight');
                if (this.canManageFiles) {
                    console.log('User can manage files');
                    let dt = event.dataTransfer
                    let files = dt.files
                    this.handleFiles(files)

                }
                else {
                    console.log('User cannot manage files');
                }


            },
            handleDrag(event) {
                console.log('Drag');
            },
            handleFileAttachmentInput()
            {
                var fileInputFiles = this.$refs.fileAttachmentElem.files
                this.handleFiles(fileInputFiles);
            },
            handleFiles(files) {
                console.log(files);
                ([...files]).forEach(this.uploadFile)
            },
            uploadFile(file) {

                let formData = new FormData()
                formData.append('file', file)

                // If this is a new post we upload to the user's TMP area and then process the files when the form is submitted
                let url = this.getPostFilesUrl();

                axios.post(url, formData).then((response) => {
                    console.log(response.data);
                    this.$message({message: 'The file was uploaded successfully.', type: 'success'});
                    this.attachments.push(response.data);
                    this.attachments = _.sortBy(this.attachments, ['file_name']);
                    // this.documentLibrary = response.data;
                }).catch((error) => {
                    console.log(error);
                    this.handleHTTPError(error);
                    this.$message({message: 'There was a problem uploading the file.', type: 'error'});
                });


            },
            getPostFilesUrl() {
                let url;
                if (this.modelId == null) {
                    url = '/api/v1/media/' + this.collectionName + '/files';
                }
                else {
                    url = '/api/v1/media/' + this.collectionName + '/' + this.modelType + '/' + this.modelId + '/files';
                }
                return url;
            },
            getFileUrl(file)
            {
                return "/club/" + this.modelType + "/" + this.post_id + "/files/" + file.id;
            },
            deleteFile(file)
            {
                console.log('Deleting file');
                console.log(file);

                let formData = new FormData()
                formData.append('_method', 'DELETE')

                axios.post('/api/v1/media/' + file.id, formData).then((response) => {
                    console.log(response.data);
                    this.$message({message: 'The file was removed successfully.', type: 'success'});
                    this.attachments = _.filter(this.attachments, function(f) { return f.id != file.id; });
                    // this.attachments.push(response.data);
                    this.attachments = _.sortBy(this.attachments, ['file_name']);
                }).catch((error) => {
                    console.log(error);
                    this.handleHTTPError(error);
                    this.$message({message: 'There was a problem removing the file.', type: 'error'});
                });
            },
            getAttachments() {
                console.log('getAttachments');
                if (this.modelId == null) {
                    this.attachments = [];
                    return;
                }
                let url = '/api/v1/media/' + this.collectionName + '/' + this.modelType + '/' + this.modelId + '/files'
                axios.get(url).then((response) => {
                    console.log(response.data);
                    this.attachments = response.data;
                }).catch((error) => {
                    this.$message({message: 'There was a problem loading files.', type: 'error'});
                });
            },
            handleHTTPError(error) {
                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        console.log(error.response.data); // Error message
                        console.log(error.response.status);
                        console.log(error.response.headers);
                        // this.$message({message: 'Error: ' + error.response.data, type: 'error'});
                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        console.log(error.request);
                        // this.$message({message: 'There was a problem updating the team - please try again.', type: 'error'});
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        console.log('Error', error.message);
                        // this.$message({message: 'There was a problem updating the team - please try again.', type: 'error'});
                    }
                    console.log(error.config);
            },
        },

        watch: {
            form: {
                handler: function(value, oldValue) {
                    if (value.publish_facebook == true && this.pages.length < 2) {
                        this.getPages();
                    }
                },
                deep: true
            },
            tags: {
                handler: function (value, oldValue) {
                    this.form.tags = this.tags.join(',');
                }
            }
        }
    }
</script>
